<template>
  <Container>
    <PageHeader
        :perPage="false"
        :title="$options.name"
    >
    </PageHeader>
    <div class="card p-4">
      <div v-if="!isHideFilter">
        <div class="form-group">
          <label for="" class="form-label">Date</label>
          <input type="date" class="form-control" v-model="date"/>
        </div>
        <div class="form-group">
          <label for="" class="form-label">Gudang</label>
          <selectize v-model="id_gudangs"  :settings="{  maxItems: 99, plugins: ['remove_button'] }" multiple data-placeholder="Pilih Gudang" required>
            <option :value="d.id" v-for="(d, i) in gudang" :key="i"> {{ d.nama_gudang }}</option>
          </selectize>
        </div>
        <div class="form-group">
          <label for="brand" class="form-label">Principal</label>
          <selectize
              id="principal"
              v-model="id_principals"
              data-placeholder="Pilih Principal"
              :settings="{  maxItems: 99, plugins: ['remove_button'] }" multiple
              :disabled="loading"
          >
            <option :value="d.id" v-for="(d, i) in principal" :key="i"> {{d.nama_principal}} </option>
          </selectize>
        </div>
        <div class="form-group">
          <label class="form-label">Barang</label>
          <selectize
              data-placeholder="Pilih Barang"
              v-model="id_barangs"
              :settings="{  maxItems: 99, plugins: ['remove_button'] }" multiple
              :disabled="loading"
          >
            <option :value="d.id" v-for="(d, i) in barang" :key="i"> {{d.kode_barang}} - {{d.nama_barang}} </option>
          </selectize>
        </div>
      </div>
      <div class="form-group">
        <ButtonFilter :text="isHideFilter ?'Show Filter' : 'Hide Filter'" :action="() => {
          isHideFilter = !isHideFilter;
        }"></ButtonFilter>
        <button @click="() => _fetchData()" :disabled="loading" class="btn btn-primary  mr-3"
                v-html="ic('search')+' Fetch Data'"/>
        <ButtonExcel :loading="loading" :action="() => _createExcel()"></ButtonExcel>
      </div>
    </div>
    <div v-if="reports.length > 0" class="card">
      <div class="table-responsive">
        <table class="table table-vcenter table-hover card-table table-striped">
          <thead>
          <tr>
            <th nowrap>Warehouse Name</th>
            <th nowrap>Warehouse ID</th>
            <th nowrap>Product Name</th>
            <th nowrap>Product Custom Code</th>
            <th nowrap>Product ID</th>
            <th nowrap>UOM</th>
            <th nowrap>Initial Stock</th>
            <th nowrap>Converted</th>
            <th nowrap>Inbound</th>
            <th nowrap>Outbound</th>
            <th nowrap>Transfer In</th>
            <th nowrap>Transfer Out</th>
            <th nowrap>Adjustment</th>
            <th nowrap>Stock on Sale</th>
            <th nowrap>Stock on Prepare</th>
            <th nowrap>Stock on Hand</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in reports" :key="i">
            <td nowrap>{{ row.warehouse_name }}</td>
            <td>{{ row.warehouse_id }}</td>
            <td nowrap>{{ row.product_name }}</td>
            <td>{{ row.product_custom_code }}</td>
            <td>{{ row.product_id }}</td>
            <td>{{ row.uom }}</td>
            <td>{{ row.initial_stock }}</td>
            <td>{{ row.convert }}</td>
            <td>{{ row.inbound }}</td>
            <td>{{ row.outbound }}</td>
            <td>{{ row.transfer_in }}</td>
            <td>{{ row.transfer_out }}</td>
            <td>{{ row.adjustment }}</td>
            <td>{{ row.stock_on_sale }}</td>
            <td>{{ row.stock_on_prepare }}</td>
            <td>{{ row.stock_on_hand }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Container>
</template>
<script>
import helper from "@/assets/js/helper.js";
import moment from "moment";
import {mapActions} from "vuex";
import $axios from "@/api";

export default {
  name: "ReportStockV2",
  components: {},
  mixins: [helper],
  data() {
    return {
      isHideFilter: false,
      loading: false,
      id_gudangs: [],
      id_principals: [],
      id_barangs : [],
      gudang: [],
      reports: [],
      principal : [],
      barang: [],
      date: moment(new Date).format("YYYY-MM-DD"),
    };
  },
  computed: {},
  methods: {
    ...mapActions('gudang', ['getListGudang']),
    ...mapActions('principal', ['getListPrincipal']),
    ...mapActions('barang', ['getListBarang']),
    _getListGudang() {
      this.getListGudang({}).then(res => {
        this.gudang = res
      })
    },
    _getPrincipal(){
      this.getListPrincipal({}).then( res => {
        this.principal = res
      })
    },
    _getBarang(){
      this.getListBarang({}).then( res => {
        this.barang = res
      })
    },
    async _fetchData() {
      this.loading = true;
      this.reports = [];
      for (let i = 0; i < this.id_gudangs.length; i++) {
        const id_gudang = this.id_gudangs[i];
        try {
          const response = await $axios.get('v2/report/stocks', {
            params: {
              date: this.date,
              id_gudang: id_gudang,
              id_principals: this.id_principals,
              id_barangs: this.id_barangs,
            }
          })
          this.reports = this.reports.concat(response.data);
        } catch (e) {
          helper.methods.toast(e)
        }
      }
      this.loading = false
    },
    async _createExcel() {
      this.loading = true
      await this.createExcel({
        data: this.reports,
        filename: "report-stock-" + this.date,
      });
      this.loading = false
    }
  },
  mounted() {
    this._getListGudang()
    this._getPrincipal()
    this._getBarang()
  },
  created() {
  },
};
</script>
